import { levelToGradeLevel } from 'utilities/data';
import { getQuizEndpoint } from 'utilities/context';

export const recordResponse = ({
    response = {},
    quizContext = {},
    analyticsContext = {},
    packageSettings = {},
    analyticsSettings = {}
}) => {
    const context = {
        ...quizContext,
        respondentId: `${analyticsContext.user?.id}`,
        groupId: analyticsContext['Group ID'],
        customerId: analyticsContext['Customer']?.id,
        affiliateId: analyticsContext['Affiliate']?.id,
        projectId: analyticsContext['Project UUID'],
        projectRefId: analyticsContext['Project Ref ID'],
        playSessionId: analyticsContext['Play Session'],
        packageId: packageSettings?.packageId,
        reportingId: packageSettings?.reportingId,
        embedRefId: analyticsSettings?.refId,
        language: analyticsContext.loc?.lang || 'en'
    };

    response.interactiveVideoContentId = analyticsContext.contentId;
    response.gradeBand = levelToGradeLevel(analyticsContext.level);

    if (document.referrer?.length > 256) {
        const [referrer] = document.referrer.split('?');
        context.referrer = referrer?.slice(0,255); // base url could still be gt than 256
        context.referrerTruncated = true;
    } else if (document.referrer) {
        context.referrer = document.referrer;
        context.referrerTruncated = false;
    }

    if (document.location?.href?.length > 256) {
        const [href] = document.location.href.split('?');
        context.href = href?.slice(0,255); // base url could still be gt than 256
        context.hrefTruncated = true;
    } else if (document.location?.href) {
        context.href = document.location.href;
        context.hrefTruncated = false;
    }

    const body = JSON.stringify({
        ...response,
        context
    });

    const QUIZ_RESPONSE_COLLECTION = getQuizEndpoint(analyticsContext['Group ID']);

    return fetch(QUIZ_RESPONSE_COLLECTION, {
        method: 'POST',
        keepalive: true,
        headers: {
            'Content-Type': 'application/json'
        },
        body,
        credentials: 'include'
    })
}